import { forwardRef } from 'react';

import { Button } from '@breezeventures/ui-kit/button';
import { Icon } from '@breezeventures/ui-kit/next/icon';

import { getFormattedRange } from '../../lib/get-formatted-range';

type Props = {
  value?: string;
  onClick?: () => void;
  size?: 's' | 'm';
};

const PLACEHOLDER = 'Select a period';

export const Trigger = forwardRef<HTMLButtonElement, Props>(
  ({ value, onClick, size = 'm' }, ref) => {
    const label = getFormattedRange(value) || PLACEHOLDER;

    return (
      <Button
        ref={ref}
        type="button"
        variant="secondary"
        size={size}
        onClick={onClick}
      >
        <Button.Icon>
          <Icon name="calendar" size={24} version="v1" />
        </Button.Icon>
        {label}
      </Button>
    );
  }
);

Trigger.displayName = 'DateRangePickerTrigger';
